import {DemoStepWidget, DemoWidgetType} from '../demoStepWidget';

export class WidgetQuizGame implements DemoStepWidget {
    type = DemoWidgetType.QUIZ_GAME_WIDGET;
}
